// extracted by mini-css-extract-plugin
export default {"icon-size":"24","container":"resume_container__f18P9","content":"resume_content__JWgmv"};